<template>
  <div class="table-responsive">
    <table class="table table-striped jambo_table bulk_action">
      <thead>
        <tr class="headings">
          <th class="column-title col-sm-1 fontSize16">呼號</th>
          <th class="column-title col-sm-4 fontSize16">狀態</th>
          <th class="column-title col-sm-4 fontSize16"></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, index) in list">
          <tr class="headings" style="color: black">
            <th class="announcer column-title fontSize16">
              {{ item.callNumber }}
            </th>
            <th class="subject column-title fontSize16">
              {{ item.success ? `新增成功(${item.result})` : '新增失敗' }}
            </th>
            <th class="subject column-title fontSize16">
              <button
                class="btn btn-primary"
                v-if="!item.success"
                @click="renew(index, item.position, item.reservationInfo)"
              >
                重新派單
              </button>
            </th>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import API from '../assets/js/libs/API'

export default {
  props: ['list'],
  methods: {
    renew(index, position, reservation) {
      API.post(
        `reservation/?position=${position}&method=designation`,
        reservation,
      )
        .then((res) => {
          if (res.success === true) {
            this.$emit('renewSuccess', {
              index,
              success: true,
            })
          } else {
            this.$emit('renewSuccess', {
              index,
              success: false,
            })
          }
        })
        .catch((err) => {
          this.$emit('renewSuccess', {
            index,
            success: true,
          })
          console.log(err)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/PreviousDesignationTable.vue